import { Reveal, SectionLabel } from "./Reveal";
import { STEPS } from "../../data";

export const HowItWorks = () => (
  <section
    id="process"
    data-testid="process-section"
    className="relative border-t border-white/10 bg-[#080808] py-24 md:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Reveal>
            <SectionLabel>[ How It Works ]</SectionLabel>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-heading text-4xl font-black uppercase leading-none tracking-tight text-white md:text-6xl">
              A repeatable
              <br />
              development loop
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <p className="max-w-sm font-body text-white/55">
            No two athletes get the same plan. Everyone follows the same proven process.
          </p>
        </Reveal>
      </div>

      <div className="relative grid grid-cols-1 gap-px md:grid-cols-3">
        {/* connecting line */}
        <div className="absolute left-0 right-0 top-[46px] hidden h-px bg-gradient-to-r from-[#00F0FF]/0 via-[#00F0FF]/40 to-[#00F0FF]/0 md:block" />

        {STEPS.map((s, i) => (
          <Reveal
            key={s.num}
            delay={i * 0.15}
            className="relative bg-[#080808] px-2 pt-2 md:px-8"
            data-testid={`process-step-${i}`}
          >
            <div className="relative z-10 mb-8 flex h-[88px] w-[88px] items-center justify-center border border-white/15 bg-[#050505]">
              <span className="font-mono text-3xl font-bold text-[#00F0FF]">{s.num}</span>
            </div>
            <h3 className="font-heading text-3xl font-bold uppercase tracking-tight text-white">
              {s.title}
            </h3>
            <p className="mt-4 max-w-xs font-body text-sm leading-relaxed text-white/55">
              {s.desc}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
